import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import type { LoadCategory } from '~/data/api/client/ders'

/**
 * Hook that returns a formatter for the kind of consumer a load represents.
 *
 * Reads the `settings.loads` namespace so every load surface shows the same
 * words. The template literal keeps the key a literal union, so TS still
 * verifies each member against the locale file.
 */
export default function useLoadCategoryFormatter() {
  const t = useTranslations('settings.loads')
  return useCallback((loadCategory: LoadCategory): string => t(`LoadsSettingsPage_categories_${loadCategory}`), [t])
}
